import { render, staticRenderFns } from "./EditRank.vue?vue&type=template&id=61040b3a&scoped=true&"
import script from "./EditRank.vue?vue&type=script&lang=ts&"
export * from "./EditRank.vue?vue&type=script&lang=ts&"
import style0 from "./EditRank.vue?vue&type=style&index=0&id=61040b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61040b3a",
  null
  
)

export default component.exports